import { type InferType } from "yup";
import { AccountDetailsInputSchema } from "./AccountDetails/constants";
import { BankDetailsInputSchema } from "./BankDetails/constants";

export const WirePaymentPrefInputSchema = BankDetailsInputSchema.concat(
  AccountDetailsInputSchema,
);

export type WirePaymentPrefInputType = InferType<typeof WirePaymentPrefInputSchema>;
